import { createRouter as createVueRouter, createWebHashHistory } from "vue-router";
import { setRouter } from "./navigator";
import { getRoutes, addRoute } from "./routes";

export function createRouter() {
  const routes = getRoutes();
  if (__DEV__) {
    console.debug("routes:", routes);
  }
  const router = createVueRouter({
    history: createWebHashHistory(),
    routes,
  });
  return setRouter(router);
}

export { addRoute };
